<template>
<div class="register">
    <div class="item">
        <label class="title"><span class="required">*</span>地区</label>
        <my-select placeholder='请选择地区' v-model.trim="user.areaA" :options="areaLst"  :selectedValue="user.areaA" @changeSelected="setAddress()"></my-select>
        <p class="error" v-if="!$v.user.areaA.required" :class="{'no-error':!$v.user.areaA.$error}">请选择地区</p>
    </div>
    <div class="item">
        <label class="title"><span class="required">*</span>姓</label>
        <input placeholder="请输入姓" type="text" v-model="user.firstName" @blur="$v.user.firstName.$touch()" @input="setMaxLength('firstname')">
        <p class="error" v-if="!$v.user.firstName.required" :class="{'no-error':!$v.user.firstName.$error}">请输入姓</p>
    </div>
    <div class="item">
        <label class="title"><span class="required">*</span>名</label>
        <input placeholder="请输入名" type="text" v-model="user.lastName" @blur="$v.user.lastName.$touch()" @input="setMaxLength('lastname')">
        <p class="error" v-if="!$v.user.lastName.required" :class="{'no-error':!$v.user.lastName.$error}">请输入名</p>
    </div>
    <div class="item" v-if="user.areaA=='中国大陆'">
        <label class="title"><span class="required">*</span>手机</label>
        <input placeholder="请输入手机号" type="text" v-model.trim="user.mobile" @blur="$v.user.mobile.$touch()" maxlength="11">
        <p class="error" v-if="!$v.user.mobile.required" :class="{'no-error':!$v.user.mobile.$error}">请输入手机号</p>
        <p  class="error" v-if="$v.user.mobile.$dirty&&$v.user.mobile.required&&!$v.user.mobile.isRight">请输入正确的手机格式</p>
        <p class="error" v-if="$v.user.mobile.$dirty&&$v.user.mobile.required&&!$v.user.mobile.isUnique&&mobileError">您输入的手机已注册，请登录</p>
    </div>
    <div class="item" v-if="user.areaA!='中国大陆'">
        <label class="title"><span class="required">*</span>手机</label>
        <input placeholder="请输入手机号" type="text" v-model.trim="user.mobile" @blur="$v.user.mobile.$touch()" maxlength="15">
        <p class="error" v-if="!$v.user.mobile.required" :class="{'no-error':!$v.user.mobile.$error}">请输入手机号</p>
        <p  class="error" v-if="$v.user.mobile.$dirty&&$v.user.mobile.required&&!$v.user.mobile.isRight">请输入正确的手机格式</p>
        <p class="error" v-if="$v.user.mobile.$dirty&&$v.user.mobile.required&&!$v.user.mobile.isUnique&&mobileError">您输入的手机已注册，请登录</p>
    </div>
    <div class="item" v-if="user.areaA=='中国大陆'">
        <label class="title"><span class="required">*</span>验证码</label>
        <input class="yzm" placeholder="请输入验证码" type="text" v-model.trim="user.yzm"  maxlength="6" @blur="$v.user.yzm.$touch()">
        <input type="button" class="btn btn-yzm" value="获取验证码" v-if="!timeShow" @click="sendYzm">
        <div class="btn btn-time" v-if="timeShow">{{displayTime}}s</div>
        <p class="error" v-if="!$v.user.yzm.isRequired" :class="{'no-error':!$v.user.yzm.$error}">请输入验证码</p>
        <p class="error" v-if="yzmError!=''">{{yzmError}}</p>
    </div>
    <div class="item">
        <label class="title"><span class="required">*</span>邮箱</label>
        <input placeholder="请输入邮箱" type="text" v-model.trim="user.emailNew" @blur="$v.user.emailNew.$touch()">
        <p class="error" v-if="!$v.user.emailNew.required" :class="{'no-error':!$v.user.emailNew.$error}">请输入邮箱</p>
        <p class="error" v-if="$v.user.emailNew.$dirty&&$v.user.emailNew.required&&!$v.user.emailNew.isRight">请输入正确的邮箱</p>
    </div>
    <div class="item">
        <label class="title"><span class="required">*</span>公司</label>
        <input placeholder="请输入公司" type="text" v-model="user.enterprise" @blur="$v.user.enterprise.$touch()">
        <p class="error" v-if="!$v.user.enterprise.required" :class="{'no-error':!$v.user.enterprise.$error}">请输入公司</p>
    </div>
    <div class="item">
        <label class="title"><span class="required">*</span>职位</label>
        <my-select placeholder='请选择职位' v-model="user.zhiwei" :options="positionLst"  :selectedValue="user.zhiwei"></my-select>
        <p class="error" v-if="!$v.user.zhiwei.required" :class="{'no-error':!$v.user.zhiwei.$error}">请选择职位</p>
    </div>
    <div class="item" v-if="user.areaA!='其他'">
        <label class="title address-title"><span class="required">*</span>地址</label>
        <div class="address" :class="{'static':provinceShow||cityShow}">
            <div class="select">
                <div class="select-show" :class="{input: address!='请选择地址'}" @click="showProvince">{{address}}</div>
            </div>
            <span class="select-icon"><img class="icon-img" :src="arrowSrc"></span>
            <div class="address-content" v-if="provinceShow">
                <div class="select-address" v-if="isMobile">请选择地址<img src="../assets/img/close.png" @click="closeAddress"/></div>
                <div class="address-text"><span :class="{'has-value':user.province!='请选择'}">{{user.province}}</span></div>
                    <div class="province">
                    <label v-for="item in localProvinces" @click="showCity(item)">{{item.name}}</label>
                    </div>
            </div>
            <div class="address-content" v-if="cityShow">
                <div class="select-address" v-if="isMobile">请选择地址<img src="../assets/img/close.png" @click="closeAddress"/></div>
                <div class="address-text"><span :class="{'has-value':user.province!='请选择'}" @click="showProvince">{{user.province}}</span><span>请选择</span></div>
                <div class="province">
                    <label  v-for="item in cityLst" @click="setCity(item)">{{item.name}}</label>
                </div>
            </div>
        </div>
        <p class="error" v-if="!$v.user.province.isRequired&&!$v.user.city.isRequired" :class="{'no-error':!$v.user.province.$error}">请输入地址</p>
    </div>
    <div class="item" v-if="user.areaA=='其他'">
        <label class="title"><span class="required">*</span>国家</label>
        <input placeholder="请输入国家" type="text" v-model="user.country" @blur="$v.user.country.$touch()" maxlength="50">
        <p class="error" v-if="!$v.user.country.required" :class="{'no-error':!$v.user.country.$error}">请输入国家</p>
    </div>
    <div class="item" v-if="user.areaA=='其他'">
        <label class="title"><span class="required">*</span>州省</label>
        <input placeholder="请输入州省" type="text" v-model="user.province" @blur="$v.user.province.$touch()" maxlength="100">
        <p class="error" v-if="!$v.user.province.required" :class="{'no-error':!$v.user.province.$error}">请输入州省</p>
    </div>
    <div class="item" v-if="user.areaA=='其他'">
        <label class="title"><span class="required">*</span>市县</label>
        <input placeholder="请输入市县" type="text" v-model="user.city" @blur="$v.user.city.$touch()" maxlength="100">
        <p class="error" v-if="!$v.user.city.required" :class="{'no-error':!$v.user.city.$error}">请输入市县</p>
    </div>
    <div class="item" v-if="user.areaA=='其他'">
        <label class="title"><span class="required">*</span>邮编</label>
        <input placeholder="请输入邮编" type="text" v-model="user.postCode" @blur="$v.user.postCode.$touch()" maxlength="10">
        <p class="error" v-if="!$v.user.postCode.required" :class="{'no-error':!$v.user.postCode.$error}">请输入邮编</p>
    </div>
    <div class="item" v-show="showDetailAddress||user.areaA=='其他'">
        <label class="title hidden"><span class="required">*</span>详细地址</label>
        <input placeholder="请输入您所在的详细地址" type="text" v-model="user.dAddress" @blur="$v.user.dAddress.$touch()" maxlength="100">
        <p class="error" v-if="!$v.user.dAddress.required" :class="{'no-error':!$v.user.dAddress.$error}">请输入详细地址</p>
    </div>
    <div class="item-btn">
        <div class="btn submit" @click="createUser">提交</div>
        <div class="btn-back"><span><a :href="backUrl">返回</a></span></div>
    </div>
    <div class="modal" v-if="isMobile&&(provinceShow||cityShow)" :style="{height:scrollHeight+'px'}"></div>
</div>
</template>

<script>
    import config from '../config';
    import postCodeCitys from '../assets/Cities';
    import {setUser,setKeeLogin} from '../utils/public'
    import { required } from 'vuelidate/lib/validators';
    import  md5 from "md5";
    import Select from '../components/SelectField.vue'
    import {getDic,getForm,checkUnique,sendCheckCode,checkCode,userRegister} from '../utils/member'
    export default {
        name: "register",
        components: {
            'my-select': Select,
        },
        data(){
            return{
                scrollHeight:0,
                isMobile:/Android|webOS|iPhone|iPod|BlackBerry|ios|iPad/i.test(navigator.userAgent),
                arrowSrc:/Android|webOS|iPhone|iPod|BlackBerry|ios|iPad/i.test(navigator.userAgent)?require('../assets/img/arrow-wap.png'):require('../assets/img/arrow-icon.png'),
                backUrl:"",
                areaLst:[],
                user:{
                    areaA:"中国大陆",
                    firstName:'',
                    lastName:'',
                    password:'',
                    mobile:'',
                    emailNew:'',//自定义邮箱，系统邮箱有重复验证
                    enterprise:'',
                    zhiwei:'',
                    country:'',
                    province:'',
                    postCode:'',
                    dAddress:'',//详细地址
                    city:"",
                    address:'',//通信地址 省+市+详细地址
                    yzm:''
                },
                displayTime:60,
                timeShow:false,
                address:'请选择地址',
                positionLst:[],
                provinceLst:[],
                localProvinces:[],
                provinceShow:false,
                cityLst:[],
                cityShow:false,
                yzmError:'',
                token:'',
                btnValid:true,
                showDetailAddress:false,
                mobileError:false
            }
        },
        validations: {
            user: {
                areaA: {
                    required
                },
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                emailNew: {
                    required,
                    isRight(value){
                        if (value === '') return true
                        return /^(\w)+(.|-\w+)*@(.|-|\w)+((\.\w+)+)$/.test(value)
                    }
                },
                mobile: {
                    required,
                    isRight(value){
                        if (value === '') return true
                        if(this.user.areaA=='中国大陆'){
                            return /^(1[0-9][0-9])\d{8}$/.test(value)
                        }
                        else{
                            return /^(\+|\-){0,1}\d{4,15}$/.test(value)
                        }
                    },
                    async isUnique(value){
                        if (value === '') return true
                        if(!this.$v.user.mobile.isRight)  return true;
                        this.mobileError=false;
                        const res = await checkUnique({
                            fieldName: 'mobile',
                            unique: this.user.mobile
                        });
                        this.mobileError=true;
                        return res.content.result
                    }
                },
                enterprise: {
                    required
                },
                zhiwei: {
                    required
                },
                province: {
                   required
                },
                city: {
                   required
                },
                country:{
                    isRequired(value){
                        if(this.user.areaA!="其他") return true;
                        return value?true:false;
                    }
                },
                yzm: {
                    isRequired(value){
                        if(this.user.areaA!="中国大陆") return true;
                        return value?true:false;
                    }
                },
                dAddress:{
                    required
                },
                postCode:{
                    isRequired(value){
                        if(this.user.areaA!="其他") return true;
                        return value?true:false;
                    }
                }
            },
        },
        watch:{
            'user.yzm':function(value){
                value=value.replace(/[^\d]/g,'');
                this.user.yzm=value;
            },
            'user.emailNew':function(value){
                value=value.replace(/[\u4e00-\u9fa5]/g,'');
                this.user.emailNew=value;
            },
            'user.enterprise':function(value){
                value=value.replace(/[^a-zA-Z\u4e00-\u9fa5\s]/g,'').replace(/\s{2,}/g,'');
                if(/^[\u4e00-\u9fa5\s]+$/.test(value)){
                    if(value.length>50){
                        value=value.substring(0,50);
                    }
                }
                else if(/^[a-zA-Z\u4e00-\u9fa5\s]+$/.test(value)){
                    if(value.length>100){
                        value=value.substring(0,100);
                    }
                }
                this.user.enterprise=value;
            },
            'user.country':function(value){
                value=value.replace(/[^a-zA-Z\u4e00-\u9fa5]|\s/g,'');
                this.user.country=value;
            },
            'user.postCode':function(value){
                value=value.replace(/[^a-zA-Z0-9]|\s/g,'');
                this.user.postCode=value;
            },
        },
        methods:{
            closeAddress:function(){
                this.provinceShow=false;
                this.cityShow=false;
            },
            setAddress:function(){
                this.showDetailAddress=false;
                this.address="请选择地址";
                this.user.province="";
                this.user.city="";
                switch (this.user.areaA) {
                    case '中国大陆':this.localProvinces = this.provinceLst.filter(item => {
                        return item.name !='台湾' && item.name != '香港' && item.name != '澳门';
                    });break
                    case '台湾':this.localProvinces = this.provinceLst.filter(item => {
                        return item.name =='台湾';
                    });break
                    case '香港':this.localProvinces = this.provinceLst.filter(item => {
                        return item.name == '香港';
                    });break
                    case '澳门':this.localProvinces = this.provinceLst.filter(item => {
                        return  item.name == '澳门';
                    });break
                }
            },
            setMaxLength:function(key){
                let name='';
                switch (key) {
                    case "firstname":name=this.user.firstName.replace(/[^a-zA-Z\u4e00-\u9fa5]/g,'').replace(/\s/g,'');break;
                    case "lastname":name=this.user.lastName.replace(/[^a-zA-Z\u4e00-\u9fa5]/g,'').replace(/\s/g,'');break;
                }
                if(/^[\u4e00-\u9fa5]+$/.test(name)){
                    if(name.length>2){
                        name=name.substring(0,2);
                    }
                }
                else if(/^[a-zA-Z\u4e00-\u9fa5]+$/.test(name)){
                    if(name.length>20){
                        name=name.substring(0,20);
                    }
                }
                switch (key) {
                    case "firstname":this.user.firstName=name;break;
                    case "lastname":this.user.lastName=name;break;
                }
            },
            getProvince:async function () {
                const data = await getDic();
                if(data.result==0){
                    this.provinceLst = data.content[config.dicId];
                    this.localProvinces = this.provinceLst.filter(item => {
                        return item.name !='台湾' && item.name != '香港' && item.name != '澳门';
                    })
                }
            },
            async getFormInfo(){
                const data = await getForm();
                const me = this;
                if(data.result==0){
                    data.content.items.forEach(item=>{
                        if(item.listOptions){
                            if(item.fieldName=='areaA'){
                                item.listOptions.forEach(a=>{
                                    me.areaLst.push({name:a.optionValue});
                                })
                            }
                            if(item.fieldName=='zhiwei'){
                                let name = "";
                                item.listOptions.forEach(a=>{
                                    switch (a.optionValue) {
                                        case 'Director/VP':name='总监/VP/总经理';break;
                                        case 'Manager':name='部门经理';break;
                                        case 'Project Manager':name='项目经理';break;
                                        case 'Engineer':name='工程师';break;
                                        case 'Buyer':name='采购';break;
                                        case 'Professor':name='教授/老师';break;
                                        case 'Researcher':name='研究员';break;
                                        case 'Student':name='学生';break;
                                        case 'Other':name='其它';break;
                                    }
                                    me.positionLst.push({optionValue:a.optionValue,name:name});
                                })
                            }
                        }

                    })
                }
            },
            showProvince:function () {
                this.user.province="请选择";
                this.user.city="请选择";
                this.provinceShow=true;
                this.cityShow=false;
            },
            showCity:function (item) {
                this.user.province =item.name;
                this.cityLst =item.child[item.paramId-1];
                this.provinceShow=false;
                this.cityShow = true;
            },
            setCity:function (item) {
                this.user.city=item.name;
                this.cityShow = false;
                this.address = this.user.province+" "+item.name;
                this.showDetailAddress=true;
            },
            sendYzm:function () {
                const me =this;
                this.$v.user.mobile.$touch();
                if(this.$v.user.mobile.$invalid)return;
                this.yzmError='';
                this.user.yzm="";
                let codedata = {
                    unique: this.user.mobile,
                    action:'register'
                }
                sendCheckCode(codedata).then((res)=>{
                    if(res.result==0){
                        this.timeShow=true;
                        let inter=setInterval(()=>{
                            me.displayTime=me.displayTime-1;
                            if(me.displayTime==0){
                                clearInterval(inter);
                                me.displayTime=60;
                                me.timeShow=false;
                            }
                        },1000)
                    }
                });
            },
            sumbitRegister:function(){
                //提交注册
                const me = this;
                const postCode="";
                switch (this.user.areaA) {
                    case '中国大陆':
                        const postCity=postCodeCitys.Cities.City.filter(item=>item.CityName==me.user.city);
                        this.user.postCode=postCity.length>0?postCity[0].ZipCode:'未找到';
                        break
                    case '香港':this.user.postCode="999077";break;
                    case '澳门':this.user.postCode="999078";break;
                    case '台湾':this.user.postCode="999079";break
                }
                let name ="";
                switch (this.user.zhiwei) {
                    case '总监/VP/总经理':name='Director/VP';break;
                    case '部门经理':name='Manager';break;
                    case '项目经理':name='Project Manager';break;
                    case '工程师':name='Engineer';break;
                    case '采购':name='Buyer';break;
                    case '教授/老师':name='Professor';break;
                    case '研究员':name='Researcher';break;
                    case '学生':name='Student';break;
                    case '其它':name='Other';break;
                }
                let formdata = {
                    formData:[
                        {fieldName: "areaA", value: this.user.areaA},
                        {fieldName: "name", value: this.user.firstName+this.user.lastName},
                        {fieldName: "firstName", value: this.user.firstName},
                        {fieldName: "lastName", value: this.user.lastName},
                        {fieldName: "emailNew", value: this.user.emailNew},
                        {fieldName: "mobile", value: this.user.mobile},
                        {fieldName: "enterprise", value: this.user.enterprise},
                        {fieldName: "zhiwei", value: name},
                        {fieldName: "dAddress", value: this.user.dAddress},
                        {fieldName: "password", value: md5("111111").toUpperCase()},
                        {fieldName: "postCode", value: this.user.postCode},
                        {fieldName: "province", value: [this.user.province], otherValue: ""},
                        {fieldName: "city", value:this.user.city},
                        {fieldName: "address", value:this.user.province+" "+this.user.city+" "+this.user.dAddress}
                    ]
                };
                if(this.user.areaA=='中国大陆'){
                    formdata.token=this.token;
                    formdata.verificationCode=this.user.yzm;
                }
                if(this.user.areaA=='其他'){
                    formdata.formData.push({fieldName: "country", value: this.user.country});
                }
                userRegister(formdata).then((result)=>{
                    if(result.result==0){
                        setUser(result.content);
                        setKeeLogin(this.user.mobile);
                        window.location.href=this.backUrl;
                    }else{
                        this.btnValid = true;
                        console.log(result);
                    }
                })
            },
            createUser:function () {
                const me=this;
                if(!this.btnValid)return;
                this.$v.user.$touch();
                if(!this.$v.$invalid){
                    this.btnValid=false;
                    let data  = {
                        unique:this.user.mobile,
                        checkCode:this.user.yzm,
                        action:'register'
                    }
                    if(this.user.areaA=='中国大陆'){
                        checkCode(data).then((res)=>{
                            if(res.result==0){
                                this.yzmError='';
                                this.token = res.content.token;
                                this.sumbitRegister();
                            }
                            else{
                                this.yzmError=res.content;
                                this.btnValid = true;
                            }
                        })
                    }
                    else{
                        this.sumbitRegister();
                    }
                }
            }
        },
        created(){
            this.backUrl =this.$route.query.backUrl?decodeURIComponent(this.$route.query.backUrl):config.webUrl;
            this.getProvince();
            this.getFormInfo();
        },
        mounted(){
            this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        }
    }
</script>

<style scoped lang="scss">
.register{
    width:560px;
    margin:0 auto;
    margin-top:60px;
    .item{
        margin-top:25px;
        font-size:14px;color:#bcbcbc;
        .required{color:#e8202f;font-weight:700;}
        .title{display:inline-block;width:96px;text-align:left; font-size:18px;color:#282828}
        .address-title{vertical-align: 82%;}
        .hidden{visibility: hidden}
        .error{padding-right:10px;text-align:right;color:#e8202f;}
        .no-error{display:none;}
        >div,input[type='text']{display:inline-block;width:456px;height:50px;line-height:50px;}
        input[type='text']{
            border:1px solid #eaeaea;
            border-radius:2px;
            padding-left:15px;
        }
        input.yzm{
            width:305px;
            margin-right:12px;
        }
        .btn-yzm,.btn-time{
            display:inline-block;
            width:142px;
            height:50px;
            line-height:50px;
           // vertical-align:top;
        }
        .btn-time{
            background-color:#fad2d5;
            color:#e8202f;
            font-size:18px;
        }
        .address {
                display: inline-block;
                width: 456px;
                position: relative;
                z-index: 112;
                .select-title {
                    height: 50px;
                    padding-left: 15px;
                    flex-shrink: 0;
                    z-index: 112;
                    span {
                        color: #ff4301;
                    }
                }
                .select {
                    height: 50px;
                    position: relative;
                    background:#fff;
                    border: 1px solid #eaeaea;
                    border-radius: 2px;
                    .select-show {
                        height: 50px;
                        padding-left: 15px;
                        line-height: 50px;
                        text-align: left;
                        font-size: 14px;
                        color: #bcbcbc;
                        overflow: hidden;
                        &.input {
                            color: #282828;
                        }
                    }
                }
                .select-icon {
                    position: absolute;
                    top: 3px;
                    right: 20px;
                    width: 9px;
                    height: 50px;
                    flex-shrink: 0;

                    .icon-img {
                        width: 9px;
                        height: 15px
                    }
                }
                .address-content{
                    position:absolute;
                    width:100%;
                    top:44px;
                    z-index:20;
                    background:#fff;
                    border:1px solid #eaeaea;
                    border-top:0px;
                    /*滚动条样式*/
                    .province::-webkit-scrollbar {
                        width: 3px;
                    }
                    .province::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        background: #cecece;
                    }
                    .province::-webkit-scrollbar-track {
                        border-radius: 0;
                        background: #f1f1f1;

                    }
                    .province{
                        min-height:50px;
                        height:103px;
                        width:442px;
                        margin:5px 12px 5px 0px;
                        overflow-y:auto;
                        display:inline-flex;
                        flex-wrap:wrap;
                        justify-content: flex-start;
                        align-content:flex-start;
                        label{
                            width:73px;
                            height:30px;
                            text-align:center;
                            cursor:pointer;
                        }
                    }
                    .address-text{
                        height:30px;
                        padding-left:18px;
                        span{display:inline-block;height:37px;cursor:pointer;}
                        :first-child{
                            margin-right:25px;
                        }
                        span.has-value{
                            border-bottom:2px solid #e8202f;
                        }
                    }
                }
            }
    }
    .item-btn{
        margin:40px 0 90px 122px;
        div{cursor:pointer;}
        .submit{
            width:320px;
            height:46px;
            margin-bottom:15px;
            line-height:46px;
        }
        .btn-back{
            display:inline-block;
            width:320px;
            font-size:18px;
            text-align:center;
            color:#e8202f;
            span{
                border-bottom:1px solid #e8202f;
            }
        }
    }
}
@media (max-width:768px){
    .modal{
        position:absolute;
        left:0;
        top:0;
        z-index:999;
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.6);
    }
    .register{
        width:100%;
        padding:0 0.36rem;
        margin-top:0.56rem;
        .item{
            margin-top:0.28rem;
            font-size:0.22rem;
            .title{width:20%; font-size:0.26rem;}
            .address-title{vertical-align: 82%;}
            .error{padding-right:0.01rem;}
            .no-error{display:none;}
            >div{width:80%;height:0.82rem;line-height:0.82rem;}
            input[type='text']{
                width:80%;height:0.82rem;
                line-height:normal;
                padding-left:0.3rem;
            }
            input.yzm{
                width:3.3rem;
                margin-right:0.23rem;
            }
            .btn-yzm,.btn-time{
                width:1.85rem;
                height:0.77rem;
                line-height:0.77rem;
            }
            .btn-time{
                font-size:0.22rem;
            }
            .address {
                width: 80%;
                .select-title {
                    height:0.82rem;;
                    padding-left: 0.3rem;
                }
                .select {
                    height:0.82rem;;
                    .select-show {
                        height:0.82rem;
                        padding-left: 0.3rem;
                        line-height: 0.82rem;
                        font-size: 0.26rem;
                    }
                }
                .select-icon {
                    top: 0.04rem;
                    right: 0.3rem;
                    width: 0.12rem;
                    height:0.82rem;
                    .icon-img {
                        width: 0.12rem;
                        height: 0.2rem;
                    }
                }
                .address-content{
                    position:fixed;
                    top:auto;
                    left:0;
                    bottom:0;
                    z-index:9999;
                    width:100%;
                    height:4.5rem;
                    background:#fff;
                    .select-address{
                        height:0.25rem;
                        line-height:0.25rem;
                        padding-left:0.4rem;
                        margin:0.35rem 0.4rem 0 0;
                        img{
                            float:right;
                            width:0.25rem;
                            height:0.25rem;
                        }
                    }
                    /*滚动条样式*/
                    .province::-webkit-scrollbar {
                        width: 0.03rem;
                    }
                    .province::-webkit-scrollbar-thumb {
                    }
                    .province{
                        min-height:0.62rem;
                        height:2.6rem;
                        width: 88%;
                        margin:0 0.4rem;
                        label{
                            width:25%;
                            height:0.7rem;
                            text-align:left;
                        }
                    }
                    .address-text{
                        height:0.7rem;
                        padding-left:0.4rem;
                        font-size:0.24rem;
                        color:#888888;
                        span{
                            height:0.65rem;
                        }
                        :first-child{
                            margin-right:0.45rem;
                        }
                    }
                }
            }
            .static{
                position: static;
            }
        }
        .item-btn{
            font-size:0.26rem;
            margin:0.56rem 0 0rem 0.47rem;
            .submit{
                width:5.6rem;
                height:0.78rem;
                margin-bottom:0.18rem;
                line-height:0.78rem;
            }
            .btn-back{
                width:5.6rem;
                margin-bottom:1rem;
                font-size:0.26rem;
            }
        }
    }
}
</style>
